import type { ReactElement } from 'react';
import { formatAbsoluteDateTime } from '@/lib/date-utils';
import type { DateInput } from '@/lib/date-utils';

interface FormattedTimeProps {
  /** The timestamp to render. ISO string, `Date`, epoch millis, or nullish. */
  value: DateInput;
}

/**
 * Renders a long-style, 24-hour local timestamp (e.g.
 * `January 15, 2024 at 14:30:00`) as plain inline text. The sole caller of
 * `formatAbsoluteDateTime`, used for filter-boundary local rendering.
 *
 * Absolute only — a fixed boundary (e.g. a filter's "After" date) has no
 * meaningful relative form. Tooltip-free by design: it renders inside callers'
 * existing tooltips/lists, so it must not wrap its own.
 */
export function FormattedTime({ value }: FormattedTimeProps): ReactElement {
  return <span>{formatAbsoluteDateTime(value)}</span>;
}
